import InitialState, { UpdateRegisterAction } from "./RegisterRedux";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: InitialState = {
  userfullname: "",
  email: "",
  hasPassword: false,
  phoneNumber: 0,
  clientName: "",
  clientLogoURL: "",
  clientCompanyName: "",
  clientWebsite: "",
  clientBillingType: "",
  clientProvince: "",
  clientCity: "",
  clientDistrict: "",
  clientStreet: "",
  clientZipcode: "",
  userrole: "",
  countryCode: "",
  uid: "",
  verifyExpiredAt: "",
};

export const RegisterSlice = createSlice({
  name: UpdateRegisterAction,
  initialState: initialState,
  reducers: {
    setUserFullname: (state, action: PayloadAction<string>) => {
      state.userfullname = action.payload;
    },
    setUserEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    setHasPassword: (state, action: PayloadAction<boolean>) => {
      state.hasPassword = action.payload;
    },
    setUserPhoneNumber: (state, action: PayloadAction<number>) => {
      state.phoneNumber = action.payload;
    },
    setClientName: (state, action: PayloadAction<string>) => {
      state.clientName = action.payload;
    },
    setClientLogo: (state, action: PayloadAction<string>) => {
      state.clientLogoURL = action.payload;
    },
    setClientCompanyName: (state, action: PayloadAction<string>) => {
      state.clientCompanyName = action.payload;
    },
    setClientWebsite: (state, action: PayloadAction<string>) => {
      state.clientWebsite = action.payload;
    },
    setClientBillingType: (state, action: PayloadAction<string>) => {
      state.clientBillingType = action.payload;
    },
    setClientProvince: (state, action: PayloadAction<string>) => {
      state.clientProvince = action.payload;
    },
    setClientCity: (state, action: PayloadAction<string>) => {
      state.clientCity = action.payload;
    },
    setCLientDistrict: (state, action: PayloadAction<string>) => {
      state.clientDistrict = action.payload;
    },
    setClientStreet: (state, action: PayloadAction<string>) => {
      state.clientStreet = action.payload;
    },
    setClientZipcode: (state, action: PayloadAction<string>) => {
      state.clientZipcode = action.payload;
    },
    setUserRole: (state, action: PayloadAction<string>) => {
      state.userrole = action.payload;
    },
    setCountryCode: (state, action: PayloadAction<string>) => {
      state.countryCode = action.payload;
    },
    setUserID: (state, action: PayloadAction<string>) => {
      state.uid = action.payload;
    },
    setVerifyExpired: (state, action: PayloadAction<string>) => {
      state.verifyExpiredAt = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setUserFullname,
  setCLientDistrict,
  setClientBillingType,
  setClientCity,
  setClientCompanyName,
  setClientLogo,
  setClientName,
  setClientProvince,
  setClientStreet,
  setClientWebsite,
  setClientZipcode,
  setUserEmail,
  setHasPassword,
  setUserPhoneNumber,
  setUserRole,
  setCountryCode,
  setUserID,
  setVerifyExpired
} = RegisterSlice.actions;
// You must export the reducer as follows for it to be able to be read by the store.
export default RegisterSlice.reducer;
